import { useEffect } from 'react';

import { Form, Input, Modal } from 'antd';

import { useDispatch } from 'react-redux';
import * as userActions from '@redux/user/actions';
import { useEditMicrosoftEntraID } from 'hooks/user-profile/useEditMicrosoftEntraID';

const MicrosoftEntraIDModal = ({ visible, offModal, userProfile }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { editMicrosoftEntraIDMutation, loading } = useEditMicrosoftEntraID();

  useEffect(() => {
    if (userProfile && visible) {
      form.setFieldsValue({ microsoftEmail: userProfile?.microsoftEmail });
    }
  }, [userProfile, visible, form]);

  const handleCancel = () => {
    offModal();
  };

  const handleSave = () => {
    form.validateFields().then((values) => {
      const params = {
        userId: userProfile?.id,
        ...values,
      };

      editMicrosoftEntraIDMutation.mutateAsync(params).then(() => {
        dispatch(userActions.getUserProfile());
        offModal();
      });
    });
  };

  return (
    <Modal
      bodyStyle={{ paddingBottom: 0 }}
      title={'Change Microsoft email'}
      visible={visible}
      onOk={handleSave}
      onCancel={handleCancel}
      destroyOnClose={true}
      maskClosable={false}
      okText={'Change Microsoft email'}
      okButtonProps={{ loading }}
    >
      <Form form={form} labelCol={{ xs: 8 }} wrapperCol={{ xs: 16 }}>
        <Form.Item
          label='Microsoft email'
          name='microsoftEmail'
          rules={[
            {
              required: true,
              message: 'Microsoft email is required',
            },
            { type: 'email', message: 'Invalid email' },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default MicrosoftEntraIDModal;
